const shelf = new URL('../../icons/shelf.png', import.meta.url).href

export default {
  type: 'Shelf',
  description: 'Shelf',
  icon: shelf,
  group: 'SCS',
  model: {
    type: 'Shelf',
    left: 100,
    top: 100,
    width: 20,
    height: 20
  }
}
